module.exports = ":host {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.places-address-input {\r\n  width: 100%;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/places-address-input/places-address-input.component.css
// module id = ./src/app/shared/places-address-input/places-address-input.component.css
// module chunks = main